import Image from "components/Elements/Image/Image";

const HomeIntegrateSectionImagesAnimation = () => {
  return (
    <div className="integrate-section-wrap">
      <div className="form-image-container">
        <Image
          name="home-page-integrate-section-form"
          ext="png"
          className="form-image"
        />
        <Image
          name="home-page-integrate-section-element"
          ext="png"
          className="elements-image"
        />
        <Image
          name="home-page-integrate-section-embed"
          ext="png"
          className="embed-image"
        />
      </div>
    </div>
  );
};

export default HomeIntegrateSectionImagesAnimation;
